import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{~yield\n  (link\n    route=@route\n    models=@models\n    model=@model\n    query=@query\n    fromURL=@fromURL\n    preventDefault=@preventDefault\n  )\n~}}")